/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// local imports
import FooterLogo from '../../assets/UW_Horizontal_Logo_Full.png';

const Footer = (props) => {
    // contexts
    const { colors, fontSize } = useContext(ThemeContext);
    const { NEXT_APP_URL, version } = useContext(AuthContext);

    return (
        <footer style={{ backgroundColor: "rgba(112, 182, 70, 0.25)" }} id="footer-div">
            <div className='px-3 pt-3 pb-0'>
                <div className='text-center'>
                    <h4 id="disclaimer-heading" style={{ color: "#000" }}><b>DISCLAIMER</b></h4>
                    <p id="disclaimer-desc" style={{ color: "#000" }}>If you are in a life threatening situation, do NOT use this site. Call the 24-hour Jeevan Aastha Helpline at 1800-233-3330. If your issue is an emergency, call 100 or go to your nearest emergency center.</p>
                </div>
                <div>
                    <img id="footer-img" className='my-2' width="160px" height="auto" src={FooterLogo} />
                </div>
                <label id="footer-label" style={{ fontSize: fontSize.lg, color: "#000" }}>We are a group of psychologists who strive to bring peace and happiness in your lives by providing personalised counselling.</label>
                <div className='row mt-3'>
                    <div className="col-lg-3 col-md-6 col-6">
                        <h5 id="footer-counselling-label" className="mb-3" style={{ color: "#000" }}><b>Counselling</b></h5>
                        <ul className="list-unstyled mb-0">
                            <li className='mb-2' id="counsellors-link">
                                <a href={NEXT_APP_URL + "/counsellors"}>Counsellors</a>
                            </li>
                            <li className='mb-2' id="services-link">
                                <Link to="/services">Services</Link>
                            </li>
                            <li className='mb-2' id="Daily-Feed-link">
                                <Link to="/dailyfeed">Daily Feed</Link>
                            </li>
                            <li className='mb-2' id="Gift-voucher-link">
                                <a href="/#giftVoucher">Give a Gift Voucher</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-6">
                        <h5 id="footer-user-label" className="mb-3" style={{ color: "#000" }}><b>User</b></h5>
                        <ul className="list-unstyled">
                            <li className='mb-2' id="signup-link">
                                <Link to="/user/signup">Sign up</Link>
                            </li>
                            <li className='mb-2' id="signin-link">
                                <Link to="/user/signin">Sign in</Link>
                            </li >
                            <li className='mb-2' id="forgot-password-link">
                                <Link to="/user/forgotpassword">Forgot Password</Link>
                            </li>
                            <li className='mb-2' id="become-counsellor-link">
                                <Link to="/counsellor/pricing">Become Counsellor</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-6">
                        <h5 id="footer-support-label" className="mb-3" style={{ color: "#000" }}><b>Support</b></h5>
                        <ul className="list-unstyled">
                            <li className='mb-2' id="about-link">
                                <a href={NEXT_APP_URL + "/aboutus"}>About</a>
                            </li>
                            <li className='mb-2' id="FAQs-link">
                                <a href={NEXT_APP_URL + "/faq"}>FAQs</a>
                            </li>
                            <li className='mb-2' id="contact-us-link">
                                <a href={NEXT_APP_URL + "/contactus"}>Contact Us</a>
                            </li>
                            {/* <li className='mb-2' id="sitemap-link">
                                <Link to="/sitemap">Sitemap</Link>
                            </li> */}
                        </ul>
                    </div>
                    <div className="col-lg-3 col-md-6 col-6">
                        <h5 id="footer-policies-label" className="mb-3" style={{ color: "#000" }}><b>Policies</b></h5>
                        <ul className="list-unstyled">
                            <li id="cookie-policy-link" className='mb-2'>
                                <a href={NEXT_APP_URL + "/cookiepolicy"}>Cookie Policy</a>
                            </li>
                            <li id="terms-conditions-link" className='mb-2'>
                                <a href={NEXT_APP_URL + "/termsconditions"}>Terms and Conditions</a>
                            </li>
                            <li id="privacy-policy-link" className='mb-2'>
                                <a href={NEXT_APP_URL + "/privacypolicy"}>Privacy Policy</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 mt-3" style={{ color: '#000', fontSize: '2rem' }}>
                        <a id="facebook-account-link" href="https://www.facebook.com/Umang-Wellness-100579918460483" target="_blank"><i id="facebook-icon" className="fab fa-facebook-f"></i></a>
                        <a id="instagram-account-link" href="https://www.instagram.com/umangwellness/" target="_blank"><i id="instagram-icon" className="ml-3 fab fa-instagram"></i></a>
                        <a id="twitter-account-link" href="https://twitter.com/umangwellness" target="_blank"><i id="twitter-icon" className="ml-3 fab fa-twitter"></i></a>
                        <a id="youtube-account-link" href="https://www.youtube.com/channel/UC8lO_viyaqHyDTjNgbfqvAA" target="_blank"><i id="youtube-icon" className="ml-3 fab fa-youtube"></i></a>
                    </div>
                    <div className="col-12 mt-3">
                        <div style={{ fontSize: fontSize.sm, color: "#70B646" }}>
                            <i className="fas fa-lock mr-1"></i>
                            <label id="ssl-secured-text">
                                Secured with SSL
                            </label>
                        </div>
                        <div>
                            <label id="nextwave-link" style={{ fontSize: fontSize.md, color: "#000" }}><b>Powered by <label style={{ color: "#4C83C9", fontSize: '18px' }}>umang.ai</label></b> </label>
                        </div>
                    </div>
                </div>
            </div>
            <div className='p-3' style={{ background: "#70B646" }}>
                <div style={{ color: "#fff" }}>Copyright &copy; umangwellness.com 2020-{moment().format('YYYY')} - All rights reserved - <Link id="release-notes-link" to='/releasenotes' style={{ color: "#fff" }}>v{version}</Link></div>
            </div>
        </footer>
    )
}

export default Footer